import { PickType } from '../../codegen';

import { SubscriptionPlan } from './subscription.plan.entity';

export class SubscriptionPlanReturnDto extends PickType(SubscriptionPlan, [
  'id',
  'createdAt',
  'updatedAt',
  'deletedAt',
  'name',
  'coins',
  'projectsLimit',
  'price',
  'partner',
]) {}
